import ReactGA from 'react-ga';
import React from 'react'
import * as column from './columns'
import moment from 'moment'
import { Table, DatePicker } from 'antd'
import PropTypes from 'prop-types'
import Graph from './Graph'

class Prestarts extends React.Component {
  constructor() {
    super();
    this.state = {
      dateFrom: '',
      dateTo: ''
    }
    this.dateSelectionUpdate = this.dateSelectionUpdate.bind(this);

  }
  componentDidMount() {
    ReactGA.pageview('/prestarts');
    this.setState({
      dateFrom: moment().startOf('day').subtract(10,"day").format('YYYY-MM-DD') ,
      dateTo: moment().format('YYYY-MM-DD')
    })
  }
  dateSelectionUpdate(dates, dateStrings) {
    this.setState({
      dateFrom: moment(dateStrings[0], 'DD-MM-YYYY').format('YYYY-MM-DD'),
      dateTo: moment(dateStrings[1], 'DD-MM-YYYY').format('YYYY-MM-DD')
    })
  }
  render () {
    function checkData() { if (prestartData.length === 0) { return true } else { return false }}

    var prestartData = [];
    var countOperational = 0;
    var countMaintenance = 0;
    var countService = 0;

    if (this.props.prestarts) {
      for (var i = 0; i < this.props.prestarts.length; i++) {
        if (this.props.prestarts[i].created_at > this.state.dateFrom && this.props.prestarts[i].created_at < this.state.dateTo) {
          if (this.props.prestarts[i].status === "No Work Required") {
            var status = "Operational";
            countOperational++;
          } else if (this.props.prestarts[i].status === "Work Required") {
            status = "Maintenance Required";
            countMaintenance++;
          }
          
          if(this.props.prestarts[i].form_values["38e9"]) {
            var str = this.props.prestarts[i].form_values["38e9"];
            var regex = new RegExp(',', 'g');
            //replace via regex
            str = str.replace(regex, '');
            var fixIt = str;
            if (this.props.prestarts[i].form_values["38e9"].includes('Service Due.')) {
              countService++
              status = "Service Due";
            }
          }
          else {fixIt = ""}
          if(this.props.prestarts[i].form_values[2155]) { var priority = this.props.prestarts[i].form_values[2155].choice_values["0"]; }
          else {
            priority = ""
          }
          if(this.props.prestarts[i].form_values.c501) { var comments = this.props.prestarts[i].form_values.c501; }
          else {
            comments = ""
          }
          var date = this.props.prestarts[i].form_values.fdf9;
          var id = this.props.prestarts[i].id;
          prestartData.push({
            psID: id,
            psDate: date,
            psStatus: status,
            psOn: this.props.prestarts[i].form_values["94a5"],
            psComments: comments,
            psFix: fixIt,
            psFrom: this.props.prestarts[i].form_values["947b"].choice_values["0"],
            psPriority: priority
          })
        }
      }
      prestartData.sort((a, b) => {
        var aDate = a.psDate;
        var bDate = b.psDate;

        return (aDate > bDate) ? -1 : 1;
      });
    }
    
    return(
      <div>
        <h1>Prestarts</h1>
        <h4>The default date range is from the previous 10 days.</h4>
        <DatePicker.RangePicker
          ranges={{
            "Previous 10 Days": [moment().startOf('day').subtract(10,"day"), moment()],
            "Previous 30 Days": [moment().startOf('day').subtract(30,"day"), moment()],
            "This Year": [moment().startOf('year'), moment().endOf('year')]
          }}
          defaultValue={[moment().startOf('day').subtract(10,"day"), moment()]}
          format="DD-MM-YYYY"
          onChange={this.dateSelectionUpdate}
          style={{padding: '20px 0'}}
        />
        <Graph data={[countOperational, countService, countMaintenance]}/>
        <h2>Details</h2>
        <Table
          pagination={false}
          id='boresTableTwo'
          loading={checkData()}
          className='tableResizer'
          columns={column.prestartList}
          rowClassName={(record) => {
            return record.psStatus;
          }}
          dataSource={prestartData}
          rowKey='psID'
        size="small" />
      </div>
    )
  }
}
Prestarts.propTypes = {
  prestarts: PropTypes.array.isRequired
}

export default Prestarts;
